import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { dynamicElementsShowMoreCollapseKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

@Component({
  selector: 'atx-show-more-collapse',
  imports: [CommonModule, AccordionModule],
  templateUrl: './ataraxia-show-more-collapse.component.html',
  styleUrls: ['./ataraxia-show-more-collapse.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@DynamicComponentRegister(dynamicElementsShowMoreCollapseKey, true)
export class AtaraxiaShowMoreCollapseComponent {
  @Input() public value: string[] = [];
  @Input() public show = 1;
}
